import { useState } from 'react'
import { useSelector } from 'statux'

import Badge from '../../../../components/Badge/Badge'
import Form from '../../../../components/Form/Form'
import TextArea from '../../../../components/TextArea/TextArea'
import RichText from '../../../../components/RichText/RichText'

import { graphqlClient, gql } from '../../../../utils/gql'

import authProvider from '../../../../utils/auth-provider'

export default function DashboardEbpcAssignments (props = {
    richText: null
}) {
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(null)

    const {
        ebpcContest,
        ebpcFinalsOpen
    } = useSelector()

    const onSubmit = async (e) => {
        const feedback = e.target.querySelector('[name=ebpc_judge_feedback]')
            .value || ''

        const mutation = await graphqlClient
            .request(gql`
                mutation {
                    update_ebpc_contests_judges (
                        where: {
                            ebpc_judge_id: { _eq: "${authProvider.getIdentity().id}" },
                            ebpc_contest_id: { _eq: ${ebpcContest.id} },
                            ebpc_finals: { _eq: ${ebpcFinalsOpen} }
                        },
                        _set: {
                            ebpc_judge_feedback: "${feedback}"
                        }
                    ) {
                        returning {
                            ebpc_judge_feedback
                        }
                    }
                }
            `, {}, {
                headers: {
                    'x-hasura-role': 'ebpc_judge'
                }
            })
            .catch((err) => {
                console.warn(err)
                return null
            })

        setFeedbackSubmitted(Boolean(mutation || false))
    }

    return (
        <div className="dashboard-ebpc-assignments-feedback">
            {feedbackSubmitted === null
                && (
                    <Form
                        onSubmit={onSubmit}
                    >
                        <p className="serif margin-3-b">
                            Tell us about your judging experience – share your feedback to help us improve the process.
                        </p>
                        <TextArea
                            name="ebpc_judge_feedback"
                            aria-label="Feedback"
                        />
                        <div className="display-flex flex-justify-content-center pad-t">
                            <button
                                className="btn btn-outline-secondary"
                                type="submit"
                                style={{
                                    borderColor: 'var(--cadet)',
                                    padding: '12px 12px 11px'
                                }}
                            >
                                Send feedback
                            </button>
                        </div>
                    </Form>)}
            {feedbackSubmitted !== null
                && (
                    <Badge
                        text={feedbackSubmitted
                            ? 'Thanks for sharing your feedback'
                            : 'There was an error sharing your feedback'}
                        type={feedbackSubmitted
                            ? 'success'
                            : 'danger'}
                    />)}
            <RichText
                className="margin-3-t"
                html={props.richText}
            />
        </div>
    )
}
